/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import * as uxstackpb from '@uxstack/sdk-proto-js/uxstack/sdk/v1/sdk_pb';
import { UUID } from '../../uuid';
import { EventContext } from './context';
import { EventPayload } from './payload';

export class EventMessage extends uxstackpb.EventMessage {
  constructor() {
    super({
      id: UUID.v4(),
      context: new EventContext(),
      createdAt: BigInt(Date.now()),
    });
  }

  public setPayload(payload: EventPayload): void {
    this.payload = payload.toPayload();
  }

  public encode(): Uint8Array {
    return this.toBinary();
  }
}
